module.exports = __webpack_public_path__ + "static/hilton-garden-inn.2604e0ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hilton-garden-inn.jpg
// module id = 631
// module chunks = 262104617495404